import adultTeeth from "@/components/TeethWidget/adultTeeth";
import childTeeth from "@/components/TeethWidget/childTeeth";

export const getToothPositionByID = (id: string) => {
  return (
    adultTeeth.find((t) => t.id === id)?.position ||
    childTeeth.find((t) => t.id === id)?.position
  );
};
